export enum CasinoGameType {
    eticket = "Eticket",
    game = "Game",
    livedealer = "LiveDealer",
    funpark = "FunParkGame",
    underground = "Underground",
}
